// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.surveyslanding_container_surveys_landing__4Plp\\+ {
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
 }

  .surveyslanding_sections_definitions__r28IR{
    flex-direction: row;
    align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  }

  .surveyslanding_sections_mandates__-TsrA{
    flex-direction: column;
    align-items: center;
  align-content: center;
  justify-content: center;
  margin-left: 20px;
  padding-left: 20px;
  }

    .surveyslanding_sections_definitions_left__W32t6{
    flex-direction: column;
    width: 50%;
    align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  }
      .surveyslanding_sections_definitions_right__comet{
    flex-direction: column;
    width: 50%;
    align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/pages/SurveyLanding/surveyslanding.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;CACd;;EAEC;IACE,mBAAmB;IACnB,uBAAuB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB;;IAEE;IACA,sBAAsB;IACtB,UAAU;IACV,uBAAuB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB;MACI;IACF,sBAAsB;IACtB,UAAU;IACV,uBAAuB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB","sourcesContent":[".container_surveys_landing {\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n }\r\n\r\n  .sections_definitions{\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: center;\r\n  }\r\n\r\n  .sections_mandates{\r\n    flex-direction: column;\r\n    align-items: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  margin-left: 20px;\r\n  padding-left: 20px;\r\n  }\r\n\r\n    .sections_definitions_left{\r\n    flex-direction: column;\r\n    width: 50%;\r\n    align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: center;\r\n  }\r\n      .sections_definitions_right{\r\n    flex-direction: column;\r\n    width: 50%;\r\n    align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: center;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_surveys_landing": `surveyslanding_container_surveys_landing__4Plp+`,
	"sections_definitions": `surveyslanding_sections_definitions__r28IR`,
	"sections_mandates": `surveyslanding_sections_mandates__-TsrA`,
	"sections_definitions_left": `surveyslanding_sections_definitions_left__W32t6`,
	"sections_definitions_right": `surveyslanding_sections_definitions_right__comet`
};
export default ___CSS_LOADER_EXPORT___;
